module.exports = __webpack_public_path__ + "img/mail.ee8dff6a.svg";